module.exports = __webpack_public_path__ + "static/1-9275860d77f14880ba44b4041d8fa03b.jpg";